import React from 'react';
interface Props {
  fillColor?: string;
}
function BoneIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={17}
      viewBox="0 0 18 17"
      fill="none">
      <path
        d="M3.98125 6.03125C3.87812 5.44375 3.36562 5 2.75 5C2.05938 5 1.5 5.55938 1.5 6.25C1.5 6.61562 1.65313 6.94062 1.90625 7.17188C2.68125 7.88438 2.68125 9.11562 1.90625 9.82812C1.65625 10.0594 1.5 10.3844 1.5 10.75C1.5 11.4406 2.05938 12 2.75 12C3.36562 12 3.87812 11.5531 3.98125 10.9688C4.11562 10.2 4.78438 9.5 5.71875 9.5H12.2812C13.2156 9.5 13.8844 10.2 14.0188 10.9688C14.1219 11.5562 14.6344 12 15.25 12C15.9406 12 16.5 11.4406 16.5 10.75C16.5 10.3844 16.3469 10.0594 16.0938 9.82812C15.3188 9.11562 15.3188 7.88438 16.0938 7.17188C16.3438 6.94062 16.5 6.61562 16.5 6.25C16.5 5.55938 15.9406 5 15.25 5C14.6344 5 14.1219 5.44687 14.0188 6.03125C13.8844 6.8 13.2156 7.5 12.2812 7.5H5.71875C4.78438 7.5 4.11562 6.8 3.98125 6.03125ZM5.45937 5.77187C5.48125 5.9 5.5875 6 5.71875 6H12.2812C12.4094 6 12.5187 5.9 12.5406 5.77187C12.7656 4.48125 13.8938 3.5 15.25 3.5C16.7687 3.5 18 4.73125 18 6.25C18 7.05312 17.6562 7.775 17.1094 8.27812C16.9813 8.39375 16.9813 8.60625 17.1094 8.72188C17.6562 9.225 18 9.94688 18 10.75C18 12.2688 16.7687 13.5 15.25 13.5C13.8938 13.5 12.7656 12.5187 12.5406 11.2281C12.5187 11.1 12.4125 11 12.2812 11H5.71875C5.59062 11 5.48125 11.1 5.45937 11.2281C5.23438 12.5187 4.10625 13.5 2.75 13.5C1.23125 13.5 0 12.2688 0 10.75C0 9.94688 0.34375 9.225 0.890625 8.72188C1.01875 8.60625 1.01875 8.39375 0.890625 8.27812C0.34375 7.775 0 7.05312 0 6.25C0 4.73125 1.23125 3.5 2.75 3.5C4.10625 3.5 5.23438 4.48125 5.45937 5.77187Z"
        fill="#17385D"
      />
    </svg>
  );
}

export default BoneIcon;
